import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'
import { FilterForm } from '@/components/filters/FilterForm'

import { DateRangePicker } from '@/views/RealtimeCoaching/components/filters/DateRangePicker'
import { AgentsDropdown } from '@/views/RealtimeCoaching/components/filters/AgentsDropdown'
import { TagsDropdown } from '@/views/RealtimeCoaching/components/filters/TagsDropdown'
import { MultiSelect } from '@/components/forms/MultiSelect'
import { FormField } from '@/components/forms/FormField'
import { setFilter } from '@/reducers/realtime/realtimeCoaching/realtimeCoaching.redux'

const AlertFiltersComponent = () => {
  const dispatch = useDispatch()
  const { data, filters, loading } = useSelector((state) => state.realtimeCoaching)

  return (
    <FilterForm sticky={false} data-testid="rtc-alerts-page-filters">
      <DateRangePicker filterKey="nullableDateRange" />
      <FormField data-testid="rtc-alerts-page-status-dropdown">
        <label>Status</label>
        <MultiSelect
          isSelectAll
          placeholderPill="All Statuses"
          options={data.alertStatus.filter(({ value }) => value !== 'pending')}
          value={filters.alertStatus}
          loading={loading.alertStatus}
          onChange={(value) => dispatch(setFilter({ alertStatus: value }))}
        />
      </FormField>
      <AgentsDropdown label="Alert on" />
      <TagsDropdown />
    </FilterForm>
  )
}

export const AlertFilters = withLDConsumer()(AlertFiltersComponent)
